import { BrowserRouter } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CountProvider } from "./context/CountContext";
import { FilterProvider } from "./context/FilterContext";
import { JWFilterProvider } from "./context/JWFilterContext";
import { LoaderProvider } from "./context/LoaderContext";
import AppRoutes from "./routes/AppRoutes";
import CommonToastContainer from "./components/Common/CommonToastContainer";

function AppContent() {
    const { toasts, removeToast } = useAuth();
    return (
        <BrowserRouter>
            <CommonToastContainer toasts={toasts} removeToast={removeToast} />
            <AppRoutes />
        </BrowserRouter>
    );
}

export default function App() {
    return (
        <PrimeReactProvider>
            <LoaderProvider>
                <AuthProvider>
                    <CountProvider>
                        <FilterProvider>
                            <JWFilterProvider>
                                <AppContent />
                            </JWFilterProvider>
                        </FilterProvider>
                    </CountProvider>
                </AuthProvider>
            </LoaderProvider>
        </PrimeReactProvider>
    );
}